import { ThePrioritiesNeeds } from '@company-common/model/kyc-form/needs-analysis/ThePrioritiesNeeds'
const thePrioritiesNeeds = new ThePrioritiesNeeds()

function priorities (
  client: 'client1' | 'client2',
  isIdentifyAnalysis: boolean
) {
  return (
    thePrioritiesNeeds.getPriorities().map(priority => {
      if (isIdentifyAnalysis) {
        return `${client}.${priority.key}`
      }

      return priority.dataDetail
        ? priority.dataDetail
        : `${client}.${priority.key}`
    }) || []
  )
}
export const CloneSectionMapping = {
  'client-summary': [
    'client1.personalDetails.title',
    'client1.personalDetails.name',
    'client1.personalDetails.nric',
    'client1.personalDetails.contactMobile',
    'client2.personalDetails.title',
    'client2.personalDetails.name',
    'client2.personalDetails.nric',
    'client2.personalDetails.contactMobile',
    'clientDeclaration.reviewDate'
  ],
  'important-notices': [
    'adviser.details.importantNoticeList',
    'clientDeclaration.marketingConsent',
    'clientDeclaration.pdpaConsent',
    'client1.personalDetails.pdpaMarketing',
    'client2.personalDetails.pdpaMarketing'
  ],
  'personal-details': ['client1.personalDetails', 'client2.personalDetails'],
  dependants: [
    'client1.personalDetails',
    'client2.personalDetails',
    'dependants'
  ],
  'trusted-individual': [
    'trustedIndividual',
    'client1.personalDetails',
    'client2.personalDetails'
  ],
  'ai-oi': ['client1.aioi', 'client2.aioi'],
  'property-financing': ['client1.propertyFinancing'],
  'risk-profile-assessment': ['client1.rpa', 'client2.rpa'],
  'customer-knowledge-assessment': ['client1.cka', 'client2.cka'],
  'cash-flow': ['client1.cashFlow', 'client2.cashFlow'],
  'net-worth': ['client1.netWorth', 'client2.netWorth'],
  budget: [
    'client1.budget',
    'client2.budget',
    'client1.thirdPartyPayor',
    'client2.thirdPartyPayor'
  ],
  insurance: ['existingPortfolio'],
  investment: ['existingInvestment'],
  'identifying-your-priorities': [
    'clientDeclaration',
    ...priorities('client1', true),
    ...priorities('client2', true)
  ],
  'needs-analysis-calculation': [
    ...priorities('client1', false),
    ...priorities('client2', false)
  ],
  'adjustments-and-assumptions': ['clientAssumptions'],
  'product-recommendations': ['recommendations'],
  'ilp-sub-funds': ['newIlpPortfolios'],
  'basis-of-recommendation': [
    'client1.rpa',
    'client2.rpa',
    'client1.recommendationBasis',
    'client2.recommendationBasis',
    'recommendations'
  ],
  'client-decision': [
    'clientDeclaration',
    'recommendations',
    'client1.recommendationBasis'
  ],
  'replacement-or-switching': [
    'client1.switching',
    'client2.switching',
    'adviser.declaration'
  ],
  bop: ['client1.beneficialOwner', 'client2.beneficialOwner'],
  pep: ['clientDeclaration'],
  ecdd: [
    'client1.ecdd',
    'client2.ecdd',
    'client1.personalDetails',
    'client2.personalDetails'
  ],
  aml: [
    'client1.personalDetails.name',
    'client1.aml',
    'client2.personalDetails.name',
    'client2.aml'
  ]
}
